<template>
  <div id="app">
    <div class="announce">
      <div class="announce-track">
        <p v-for="message in announcements" :key="message">{{ message }}</p>
      </div>
    </div>
    <header class="site-header">
      <router-link to="/" class="logo">PICKS<span>LY</span></router-link>
      <nav>
        <router-link to="/p">SHOP</router-link>
        <router-link to="/p?cat=Sneakers">SNEAKERS</router-link>
        <router-link to="/p?cat=Sandals">SANDALS</router-link>
        <router-link to="/p?cat=Boots">BOOTS</router-link>
      </nav>
      <div class="header-tools">
        <button @click="searching = !searching" aria-label="search">SEARCH</button>
        <router-link to="/login" aria-label="account">ACCOUNT</router-link>
        <router-link to="/c" class="bag" aria-label="bag">BAG <b>{{ cartCount }}</b></router-link>
      </div>
    </header>
    <div v-if="searching" class="search-row">
      <input ref="search" v-model="keyword" @keyup.enter="goSearch" placeholder="Search shoes, styles and collections"/>
      <button @click="goSearch">SEARCH</button>
    </div>
    <router-view @cart-updated="syncCart"/>
    <footer>
      <div class="footer-grid">
        <div>
          <router-link to="/" class="logo">PICKS<span>LY</span></router-link>
          <p>Everyday shoes, thoughtfully picked for the way you move.</p>
        </div>
        <div>
          <h5>SHOP</h5>
          <router-link to="/p">All Shoes</router-link>
          <router-link to="/p?cat=Sneakers">Sneakers</router-link>
          <router-link to="/p?cat=Boots">Boots</router-link>
        </div>
        <div>
          <h5>HELP</h5>
          <router-link to="/help/returns">Returns + Exchanges</router-link>
          <router-link to="/help/shipping">Shipping</router-link>
          <router-link to="/help/orders">Order Status</router-link>
          <router-link to="/help/gift-cards">Gift Cards</router-link>
          <router-link to="/help/payment">Payment Options</router-link>
          <router-link to="/help/size-guide">Size Guide</router-link>
          <router-link to="/help/privacy">Privacy Choices</router-link>
        </div>
        <div>
          <h5>STAY IN STEP</h5>
          <p>New arrivals and private offers.</p>
          <div class="subscribe"><input placeholder="Your email"/><button>GO</button></div>
        </div>
      </div>
      <div class="copyright">COPYRIGHT 2026 PICKSLY - MADE FOR EVERY STEP</div>
    </footer>
  </div>
</template>

<script>
export default {
  data: () => ({
    cartCount: 0,
    searching: false,
    keyword: '',
    announcements: [
      "They're best sellers for a reason. Shop the styles everyone's loving",
      'Ready to help you be the best dressed at every game.',
      'SUMMER SALE - UP TO 40% OFF SELECTED STYLES'
    ]
  }),
  created() {
    this.syncCart()
  },
  methods: {
    syncCart() {
      this.cartCount = JSON.parse(localStorage.getItem('picksly_cart') || '[]').reduce((n, i) => n + i.qty, 0)
    },
    goSearch() {
      if (this.keyword.trim()) this.$router.push({ path: '/p', query: { q: this.keyword } })
      this.searching = false
    }
  }
}
</script>
